// extracted by mini-css-extract-plugin
export default {"leftIcon":"R5gxV4lT6iMASFzyH_N0"};